export function obterListaCteModelo() {
  return (
    [
      { label: '57 - CTE', value: '57' },
      { label: '67 - CTE-OS', value: '67' },
    ]
  );
}
